/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CourseModule } from './courseModule';
import { UserCourseSimpleDomainsInner } from './userCourseSimpleDomainsInner';


/**
 * 
 */
export interface TrainingPlanCourse { 
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    archived?: boolean;
    /**
     * 
     */
    autoAdd?: boolean;
    /**
     * 
     */
    status?: number;
    /**
     * 
     */
    refcode?: string;
    /**
     * 
     */
    hourRegistrationHoursRequired?: number;
    /**
     * 
     */
    hourRegistrationCanAlterHoursRequired?: boolean;
    /**
     * 
     */
    hourRegistrationHasHours?: boolean;
    /**
     * 
     */
    hourRegistrationExemptionHoursType?: TrainingPlanCourse.HourRegistrationExemptionHoursTypeEnum;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    nameDu?: string;
    /**
     * 
     */
    nameNl?: string;
    /**
     * 
     */
    nameFr?: string;
    /**
     * 
     */
    nameEn?: string;
    /**
     * 
     */
    descrDu?: string;
    /**
     * 
     */
    descrNl?: string;
    /**
     * 
     */
    descrFr?: string;
    /**
     * 
     */
    descrEn?: string;
    /**
     * 
     */
    skillsDu?: string;
    /**
     * 
     */
    skillsNl?: string;
    /**
     * 
     */
    skillsFr?: string;
    /**
     * 
     */
    skillsEn?: string;
    /**
     * 
     */
    requirementsDu?: string;
    /**
     * 
     */
    requirementsNl?: string;
    /**
     * 
     */
    requirementsFr?: string;
    /**
     * 
     */
    requirementsEn?: string;
    /**
     * 
     */
    methodsDu?: string;
    /**
     * 
     */
    methodsNl?: string;
    /**
     * 
     */
    methodsFr?: string;
    /**
     * 
     */
    methodsEn?: string;
    /**
     * 
     */
    domains: Array<UserCourseSimpleDomainsInner>;
    /**
     * 
     */
    modules?: Array<CourseModule>;
}
export namespace TrainingPlanCourse {
    export type HourRegistrationExemptionHoursTypeEnum = 'day' | 'hour';
    export const HourRegistrationExemptionHoursTypeEnum = {
        Day: 'day' as HourRegistrationExemptionHoursTypeEnum,
        Hour: 'hour' as HourRegistrationExemptionHoursTypeEnum
    };
}


